import { AdminGuard } from './admin-guard';
import { SigninGuard } from './signin-guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LanguageSprachResolver } from './language-sprach.resolver';

const routes: Routes = [
  // {
  //   path: '', pathMatch: 'full', redirectTo: '/guest/signin'
  // },
  {
    path: "",
    // resolve: {lang: LanguageSprachResolver},
    children: [
      { path: 'ui-kit',
         loadChildren: () => import('./components/ui-kit/ui-kit.module').then(m => m.UiKitModule)
      },
      {
        path:  'guest',
        canActivate:[SigninGuard],
        loadChildren: () => import('./guest/guest.module').then(m =>m.GuestModule)
      },
      {
        path:"admin",
        canActivate:[AdminGuard],
        loadChildren:() => import('./admin/admin.module').then((m)=> m.AdminModule)
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/guest/signin'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
